export default function questionChunk(questions, chunkType = '', additionalCondition = null) {
    let chunks =  [];
    let lastType = null;


    questions.forEach(question => {

        if (chunks.length === 0) {
            lastType = question.type;
            chunks.push([question]);
            return;
        }

        const lastChunk = chunks.length - 1;
        const lastElOfChunk = chunks[lastChunk].length - 1;

        if(question.type === chunkType && chunks[lastChunk][lastElOfChunk].type === chunkType) {

            if(additionalCondition !== null) {
                if(additionalCondition(question) === true && additionalCondition(chunks[lastChunk][lastElOfChunk]) === true) {
                    chunks[lastChunk].push(question);
                }else {
                    chunks.push([question]);
                }
                return;
            }

            chunks[lastChunk].push(question);
        }else {
            chunks.push([question]);
        }
    });

    return chunks;
}
